import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";

type EntryType = "ALL" | "LEDGER" | "CREDIT_NOTE";

export const exportToPdf = (type: EntryType, data: any[]) => {
  let headers: string[] = [];
  let rows: any[][] = [];

  // filter + map data
  if (type === "CREDIT_NOTE") {
    headers = ["Credit Note ID", "Date", "Credit"];
    rows = data.map((note: any) => [
      note.id,
      moment(note.createdAt).format("DD MMM YYYY"),
      note.credit || "0.00",
    ]);
  } else if (type === "LEDGER") {
    headers = ["Date", "Order ID", "Credit Note ID", "Debit", "Credit"];
    rows = data.map((entry: any) => {
      const isCreditNote = entry.type === "CREDIT_NOTE";
      const orderIdDisplay = isCreditNote
        ? entry.orderIds && entry.orderIds.length > 0
          ? entry.orderIds.join(", ")
          : (entry.orderId ?? "-")
        : entry.orderId || entry.id || "-";
      const creditNoteIdDisplay = isCreditNote
        ? (entry.creditNoteId ?? entry.id ?? "-")
        : "-";
      return [
        moment(entry.dispatchDate || entry.createdAt).format("DD MMM YYYY"),
        orderIdDisplay,
        creditNoteIdDisplay,
        entry.debit || "0.00",
        entry.credit || "0.00",
      ];
    });
  } else {
    headers = ["Date", "Reference ID", "Debit", "Credit", "Type"];
    rows = data.map((entry: any) => {
      const isCreditNote = entry.type === "CREDIT_NOTE";
      // For credit notes, show the order IDs instead of credit note ID
      const orderIdDisplay = isCreditNote
        ? entry.orderIds && entry.orderIds.length > 0
          ? entry.orderIds.join(", ")
          : entry.invoiceNos && entry.invoiceNos.length > 0
            ? entry.invoiceNos.join(", ")
            : "N/A"
        : entry.orderId || entry.id || "N/A";

      return [
        moment(entry.dispatchDate || entry.createdAt).format("DD MMM YYYY"),
        orderIdDisplay,
        entry.debit || "0.00",
        entry.credit || "0.00",
        entry.type || "LEDGER",
      ];
    });
  }

  // Generate PDF
  const doc = new jsPDF();
  doc.text(
    type === "ALL"
      ? "Ledger Entries"
      : type === "LEDGER"
        ? "Ledger"
        : "Credit Notes",
    14,
    15
  );

  autoTable(doc, {
    head: [headers],
    body: rows,
    startY: 20,
  });

  const fileName =
    type === "ALL"
      ? "ledger-entries.pdf"
      : type === "LEDGER"
        ? "ledger.pdf"
        : "credit-notes.pdf";

  doc.save(fileName);
};
